var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2048 2048"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-enterprise_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "enterprise_icon",
    clipPath: "url(#clip-enterprise_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOUSE",
    transform: "translate(-341.333 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 82.773,
    height: 213.333,
    transform: "translate(1986.134 602.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 82.773,
    height: 213.333,
    transform: "translate(1986.134 1199.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M86,59.667h165.12v896H292.5V17H44.61V955.667H86Z",
    transform: "translate(1858.75 500)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 82.773,
    height: 213.333,
    transform: "translate(1986.134 901)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 82.773,
    height: 213.333,
    transform: "translate(662.187 602.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 82.773,
    height: 213.333,
    transform: "translate(662.187 1199.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 82.773,
    height: 213.333,
    transform: "translate(662.187 901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M2482.347,1967.667V1541H1282.56v426.667h-82.773V1498.333a42.667,42.667,0,0,1,42.667-42.667h578.133V5H1158.4V1157a42.667,42.667,0,1,1-82.774,0V5H910.08V1967.667H827.307V517H579.413V1967.667H496.64V1541H248.32v426.667H0V2053H2730.667v-85.333ZM620.8,559.667H785.92v896H620.8Z",
    transform: "translate(0 0)",
    fill: "#303030"
  })))));
};
export default __webpack_public_path__ + "static/media/enterprise_icon.e294acac.svg";
export { SvgComponent as ReactComponent };